import apiClient from '@/repositories/apiClient';
import { api } from './api';

export const userApi = api.injectEndpoints({
  endpoints: (build) => ({
    getUser: build.query({
      query: (id) => ({
        url: `user/${id}`,
      }),
      providesTags: (result, _err, id) => [{ type: 'Users', id: id }],
    }),
    updateUser: build.mutation({
      query: ({id, form}) => ({
        url: `user/${id}`,
        method: 'PUT',
        body: JSON.stringify({...form}),
      }),
      //invalidatesTags: ['Locations'],
      invalidatesTags: (result, error) => {
        return error ? [] : [{ type: 'Users', id: result.data?.model?.ID || 'LIST' }]
      },
    }),
    createUser: build.mutation({
      query: (form) => ({
        url: 'user',
        method: 'POST',
        body: JSON.stringify({...form}),
      }),
      invalidatesTags: (result, error) => error ? [] : [{ type: 'Users', id: 'LIST' }],
    }),
    deleteUser: build.mutation({
      query: (id) => ({
        url: `user/${id}`,
        method: 'DELETE',
      }),
      // Both the admin list (`users`) and the account list (`myusers`) can
      // show the deleted row, so invalidate both tag families.
      invalidatesTags: (result, error) =>
        error
          ? []
          : [
              { type: 'Users', id: 'LIST' },
              { type: 'MyUsers', id: 'LIST' },
            ],
    }),
    // Admin resets another user's password. `old_password` stays empty —
    // the endpoint does not require it when an admin sets the password for
    // someone else. `send_mail` optionally mails the new password to the user.
    changePassword: build.mutation({
      query: ({ id, new_password, send_mail = false, show_password = false }) => ({
        url: 'users/change_password',
        method: 'POST',
        body: JSON.stringify({
          id,
          send_mail,
          show_password,
          old_password: '',
          new_password,
        }),
      }),
    }),
  }),
})


// means, it checks for free licences
export const impersonateAs = async (userID) => {
  return await apiClient.post("/users/impersonate", JSON.stringify({ userID: userID }))
}

export const {
  useGetUserQuery,
  useLazyGetUserQuery,
  useUpdateUserMutation,
  useCreateUserMutation,
  useDeleteUserMutation,
  useChangePasswordMutation,
} = userApi;

